/**
 * @flow
 * @relayHash 791dfd79ceb53e9cbf7cc316aad3b485
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type PaginatedBackordersContainer_backorders$ref = any;
export type BackorderSortField = "BACKORDER_NUMBER" | "CREATED_AT" | "CUSTOMER" | "EXPECTED_DATE" | "ORDER_NUMBER" | "STATUS" | "UPDATED_AT";
export type BackorderStatus = "CLOSED" | "FULFILLED" | "OPEN" | "PARTIALLY_FULFILLED";
export type Permission = "CREATE_API_KEY" | "CREATE_CUSTOMER" | "CREATE_INVOICE" | "CREATE_ITEM" | "CREATE_JOB" | "CREATE_LOT" | "CREATE_ORDER" | "CREATE_PAYMENT" | "CREATE_SHIPMENT" | "DELETE_API_KEY" | "DELETE_CUSTOMER" | "DELETE_INVOICE" | "DELETE_ITEM" | "DELETE_JOB" | "DELETE_LOT" | "DELETE_ORDER" | "DELETE_SHIPMENT" | "READ_API_KEY" | "READ_CUSTOMER" | "READ_INVOICE" | "READ_ITEM" | "READ_JOB" | "READ_LOT" | "READ_ORDER" | "READ_PAYMENT" | "READ_SHIPMENT" | "UPDATE_API_KEY" | "UPDATE_CUSTOMER" | "UPDATE_INVOICE" | "UPDATE_ITEM" | "UPDATE_JOB" | "UPDATE_LOT" | "UPDATE_ORDER" | "UPDATE_SHIPMENT";
export type SortDirection = "ASC" | "DESC";
export type BackorderSort = {|
  field: BackorderSortField,
  direction: SortDirection,
|};
export type BackordersQueryVariables = {|
  count: number,
  cursor?: ?string,
  search?: ?string,
  sortBy?: ?BackorderSort,
  statuses?: ?$ReadOnlyArray<BackorderStatus>,
  customerIds?: ?$ReadOnlyArray<string>,
  orderIds?: ?$ReadOnlyArray<string>,
|};
export type BackordersQueryResponse = {|
  +viewer: ?{|
    +id: string,
    +permissions: $ReadOnlyArray<Permission>,
    +company: {|
      +id: string
    |},
  |},
  +$fragmentRefs: PaginatedBackordersContainer_backorders$ref,
|};
export type BackordersQuery = {|
  variables: BackordersQueryVariables,
  response: BackordersQueryResponse,
|};
*/


/*
query BackordersQuery(
  $search: String
  $sortBy: BackorderSort
  $statuses: [BackorderStatus!]
  $customerIds: [ID!]
  $orderIds: [ID!]
) {
  ...PaginatedBackordersContainer_backorders_1C3V1h
  viewer {
    id
    permissions
    company {
      id
    }
  }
}

fragment PaginatedBackordersContainer_backorders_1C3V1h on Query {
  backorders(first: 30, search: $search, sortBy: $sortBy, statuses: $statuses, customerIds: $customerIds, orderIds: $orderIds) {
    edges {
      cursor
      ...BackordersTable_backorderEdges
      node {
        __typename
        id
      }
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}

fragment BackordersTable_backorderEdges on BackorderEdge {
  node {
    id
    backorderNumber
    status
    expectedDate
    notes
    order {
      id
      orderNumber
    }
    customer {
      id
      name
    }
    createdAt
    updatedAt
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "count",
    "type": "Int!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "cursor",
    "type": "String",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "search",
    "type": "String",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "sortBy",
    "type": "BackorderSort",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "statuses",
    "type": "[BackorderStatus!]",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "customerIds",
    "type": "[ID!]",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "orderIds",
    "type": "[ID!]",
    "defaultValue": null
  }
],
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v2 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "viewer",
  "storageKey": null,
  "args": null,
  "concreteType": "User",
  "plural": false,
  "selections": [
    (v1/*: any*/),
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "permissions",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "company",
      "storageKey": null,
      "args": null,
      "concreteType": "Company",
      "plural": false,
      "selections": [
        (v1/*: any*/)
      ]
    }
  ]
},
v3 = {
  "kind": "Variable",
  "name": "customerIds",
  "variableName": "customerIds"
},
v4 = {
  "kind": "Variable",
  "name": "orderIds",
  "variableName": "orderIds"
},
v5 = {
  "kind": "Variable",
  "name": "search",
  "variableName": "search"
},
v6 = {
  "kind": "Variable",
  "name": "sortBy",
  "variableName": "sortBy"
},
v7 = {
  "kind": "Variable",
  "name": "statuses",
  "variableName": "statuses"
},
v8 = [
  (v3/*: any*/),
  {
    "kind": "Literal",
    "name": "first",
    "value": 30
  },
  (v4/*: any*/),
  (v5/*: any*/),
  (v6/*: any*/),
  (v7/*: any*/)
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "BackordersQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      (v2/*: any*/),
      {
        "kind": "FragmentSpread",
        "name": "PaginatedBackordersContainer_backorders",
        "args": [
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/)
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "BackordersQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "backorders",
        "storageKey": null,
        "args": (v8/*: any*/),
        "concreteType": "BackorderConnection",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "edges",
            "storageKey": null,
            "args": null,
            "concreteType": "BackorderEdge",
            "plural": true,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "cursor",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "Backorder",
                "plural": false,
                "selections": [
                  (v1/*: any*/),
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "backorderNumber",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "status",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "expectedDate",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "notes",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "order",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Order",
                    "plural": false,
                    "selections": [
                      (v1/*: any*/),
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "orderNumber",
                        "args": null,
                        "storageKey": null
                      }
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "customer",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Customer",
                    "plural": false,
                    "selections": [
                      (v1/*: any*/),
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "name",
                        "args": null,
                        "storageKey": null
                      }
                    ]
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "createdAt",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "updatedAt",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "__typename",
                    "args": null,
                    "storageKey": null
                  }
                ]
              }
            ]
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "pageInfo",
            "storageKey": null,
            "args": null,
            "concreteType": "PageInfo",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "endCursor",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "hasNextPage",
                "args": null,
                "storageKey": null
              }
            ]
          }
        ]
      },
      {
        "kind": "LinkedHandle",
        "alias": null,
        "name": "backorders",
        "args": (v8/*: any*/),
        "handle": "connection",
        "key": "PaginatedBackordersContainer_backorders",
        "filters": []
      },
      (v2/*: any*/)
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "BackordersQuery",
    "id": null,
    "text": "query BackordersQuery(\n  $search: String\n  $sortBy: BackorderSort\n  $statuses: [BackorderStatus!]\n  $customerIds: [ID!]\n  $orderIds: [ID!]\n) {\n  ...PaginatedBackordersContainer_backorders_1C3V1h\n  viewer {\n    id\n    permissions\n    company {\n      id\n    }\n  }\n}\n\nfragment PaginatedBackordersContainer_backorders_1C3V1h on Query {\n  backorders(first: 30, search: $search, sortBy: $sortBy, statuses: $statuses, customerIds: $customerIds, orderIds: $orderIds) {\n    edges {\n      cursor\n      ...BackordersTable_backorderEdges\n      node {\n        __typename\n        id\n      }\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment BackordersTable_backorderEdges on BackorderEdge {\n  node {\n    id\n    backorderNumber\n    status\n    expectedDate\n    notes\n    order {\n      id\n      orderNumber\n    }\n    customer {\n      id\n      name\n    }\n    createdAt\n    updatedAt\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '09714b2e62d575c20a7472d973abf9b0';
module.exports = node;
